import React, { useState } from "react";
import {
  Container,
  IconButton,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import { Form, Formik } from "formik";
import {
  CustomerCredentialsInitialValues,
  CustomerCredentialsValidationSchema,
  SetCustomerCredentials,
} from "../../../models/features/Customer/SetCustomerCredentials";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useSetCustomerCredentialsMutation } from "../../../redux/reducer/features/Customer/CustomerSlice";
import PageLoader from "../../../compenents/app/PageLoader";
import { useNavigate } from "react-router-dom";
export interface LoginFormValues {
  dmsDealerId?: string;
  username: string;
  password: string;
  userType?: number;
}
export interface ChangePasswordProps {
  Id?: any;
  handleClose?: any;
}

export const ChangePassword: React.FunctionComponent<ChangePasswordProps> = ({
  Id,
  handleClose,
}) => {
  const dmsDealerId = useSelector(
    (state: AppState) => state.authReducer.dmsDealerId
  );
  const { userType } = useSelector((state: AppState) => state.authReducer);
  const [addCredentialsMutation, addCredentialsMutationResult] =
    useSetCustomerCredentialsMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);
  const handleShowPasswordChange = () => setShowPassword(!showPassword);
  const handleShowConfPasswordChange = () =>
    setShowConfPassword(!showConfPassword);
  const [errorMessage, setErrorMessage] = React.useState("");
  const navigate = useNavigate();

  const handleOnSubmit = (values: SetCustomerCredentials) => {
    setErrorMessage("");
    values.customerId = Id;
    values.dmsDealerId = dmsDealerId ?? "";
    console.log("Customer credentials values", values);
    addCredentialsMutation({ data: values });
  };
  React.useEffect(() => {
    if (
      addCredentialsMutationResult.data &&
      addCredentialsMutationResult.isSuccess
    ) {
      if (
        addCredentialsMutationResult.data &&
        addCredentialsMutationResult.data.status === 200
      ) {
        if (userType === "User") {
          handleClose();
        } else {
          //navigate("/");
        }
      } else {
        setErrorMessage("Sorry, We could not change your password.");
      }
    }
  }, [addCredentialsMutationResult]);
  return (
    <>
      <PageLoader
        isLoading={addCredentialsMutationResult.isLoading}
      ></PageLoader>
      <Container
        component="div"
        maxWidth="xs"
        style={{ marginTop: "5%", height: "100%" }}
      >
        <Grid
          container
          style={{
            height: "100%",
            textAlign: "center",
          }}
        >
          <Grid item>
            <Formik
              initialValues={CustomerCredentialsInitialValues}
              validationSchema={CustomerCredentialsValidationSchema}
              onSubmit={(values) => {
                handleOnSubmit(values);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur }) => (
                <>
                  <Form
                    style={{
                      width: "100%",
                    }}
                  >
                    <CardContent>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="password"
                        margin="dense"
                        id="password"
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        error={!!(touched.password && errors.password)}
                        helperText={touched.password ? errors.password : ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                id="passwordVisibilityBtn"
                                onClick={handleShowPasswordChange}
                              >
                                {showPassword ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="confirmPassword"
                        margin="dense"
                        id="confirmPassword"
                        label="Confirm Password"
                        type={showConfPassword ? "text" : "password"}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.confirmPassword}
                        error={
                          !!(touched.confirmPassword && errors.confirmPassword)
                        }
                        helperText={
                          touched.confirmPassword ? errors.confirmPassword : ""
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                id="passwordVisibilityBtn"
                                onClick={handleShowConfPasswordChange}
                              >
                                {showConfPassword ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                      <Typography
                        align="left"
                        variant="body1"
                        color={"error"}
                        gutterBottom
                      >
                        {errorMessage}
                      </Typography>

                      <Box mt={2}>
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          fullWidth
                        >
                          Save
                        </Button>
                      </Box>
                    </CardContent>
                  </Form>
                </>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
